module.exports = __webpack_public_path__ + "img/app_img3.879e43d9.png";